import {
  fetchLessonClassActionplanCounts,
  fetchLessonClassActionplanFilters,
  fetchLessonClassActionplans,
} from "classroom/api/teacher";
import {
  createActionplanListStore,
  requireActionplanContext,
} from "actionplan/stores/createActionplanListStore";

export const useClassroomLessonClassActionplanStore = createActionplanListStore(
  "classroomLessonClassActionplan",
  {
    fetchList: (params, lessonClass) =>
      fetchLessonClassActionplans(
        requireActionplanContext(lessonClass),
        params,
      ),
    fetchCounts: (params, lessonClass) =>
      fetchLessonClassActionplanCounts(
        requireActionplanContext(lessonClass),
        params,
      ),
    fetchFilters: (lessonClass) =>
      fetchLessonClassActionplanFilters(requireActionplanContext(lessonClass)),
  },
);
